import React from 'react';
import {useTranslation} from 'react-i18next';
import Datepicker from 'react-tailwindcss-datepicker';
import SelectComponent from '../../../Selects/SelectComponent';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

// import { Container } from './styles';

function FiltrosHistoricoOportunidades({info}) {
    const {
        //historico de oportunidades
        filtroNomeHistorico,
        setFiltroNomeHistorico,
        filtroEtapa,
        setFiltroEtapa,
        filtroRepHisOp,
        setFiltroRepHisOp,
        filtroEmpresa,
        setFiltroEmpresa,
        filtroDt,
        setFiltroDt,
        filtroValorHistorico,
        setFiltroValorHistorico,
        etapasHistoricoOp,
        setEtapasHistoricoOp,
        representantesHistoricoOp,
        setRepresentantesHistoricoOp,
    } = info;

    const {t} = useTranslation();

    function showButton() {
        if (filtroNomeHistorico || filtroEtapa.length > 0 || filtroRepHisOp.length > 0 || filtroEmpresa || filtroDt.startDate || setFiltroValorHistorico) {
            return true;
        } else {
            return false;
        }
    }

    function limparFiltros() {
        // setFiltroCodigoHistorico('');
        setFiltroNomeHistorico('');
        setFiltroEtapa([]);
        setFiltroRepHisOp([]);
        setFiltroEmpresa('');
        setFiltroDt({
            startDate: null,
            endDate: null,
        });
        setFiltroValorHistorico('');
        setFiltroRepHisOp('');
    }

    return (
        <div className="dark:bg-gray-800">
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('nome')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroNomeHistorico}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroNomeHistorico(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('empresa')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroEmpresa}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroEmpresa(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('valor')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroValorHistorico}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroValorHistorico(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('etapa')}
                </label>
                <SelectComponent
                    options={etapasHistoricoOp}
                    value={filtroEtapa}
                    onChange={e => {
                        setFiltroEtapa(e);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('representante')}
                </label>
                <SelectComponent
                    options={representantesHistoricoOp}
                    value={filtroRepHisOp}
                    onChange={e => {
                        setFiltroRepHisOp(e);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>

            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('dataCriacao')}
                </label>
                <Datepicker
                    displayFormat="DD/MM/YYYY"
                    useRange={false}
                    asSingle={false}
                    value={filtroDt}
                    onChange={newValue => {
                        setFiltroDt(newValue);
                    }}
                    inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-lg text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                />
            </div>
            {showButton() && (
                <div className="flex flex-row justify-end mt-4">
                    <button
                        type="button"
                        onClick={() => limparFiltros()}
                        className="flex items-center font-semibold text-sm justify-center text-white bg-red-700 rounded-[8px] py-1 px-2 hover:bg-red-800 dark:bg-red-600 dark:hover:bg-red-700 focus:ring-4 focus:ring-red-300 focus:outline-none dark:focus:ring-red-800">
                        {t('limparFiltros')} <CloseRoundedIcon />
                    </button>
                </div>
            )}
        </div>
    );
}

export default FiltrosHistoricoOportunidades;
